import { __assign, __rest } from "tslib";
// DS: DEV13
import React, { useCallback } from 'react';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
import SophisticatedTooltipBase from '@wix/da-ds/pkg/tooltips/lego/SophisticatedTooltipBase';
/**
 * A SophisticatedTooltip with the UX we expect for an FTUE tooltip.
 *
 * If `heading` isn't supplied, `aria-label` is required to fulfill a11y requirements.
 */
var SophisticatedFtueTooltip = function (_a) {
    var isVisible = _a.isVisible, flag = _a.flag, _b = _a.enabled, enabled = _b === void 0 ? true : _b, consumerProvidedOnClose = _a.onClose, rest = __rest(_a, ["isVisible", "flag", "enabled", "onClose"]);
    var _c = useFirstTimeFlag(flag), hasFlag = _c.hasFlag, dropFlag = _c.dropFlag;
    var _d = usePopoverOnInteraction({ listenOnClicks: true, listenOnHover: true }), onClick = _d.onClick, onMouseEnter = _d.onMouseEnter, onMouseLeave = _d.onMouseLeave, onClose = _d.onClose;
    var handleClose = useCallback(function () {
        onClose();
        dropFlag();
        if (consumerProvidedOnClose) {
            consumerProvidedOnClose();
        }
    }, [onClose, dropFlag, consumerProvidedOnClose]);
    return (React.createElement(SophisticatedTooltipBase, __assign({ isVisible: !!hasFlag && enabled, onReferenceClick: onClick, onReferenceMouseEnter: onMouseEnter, onReferenceMouseLeave: onMouseLeave, onClose: handleClose }, rest)));
};
SophisticatedFtueTooltip.displayName = 'SophisticatedFtueTooltip';
export default SophisticatedFtueTooltip;
//# sourceMappingURL=SophisticatedFtueTooltip.js.map